import * as React from 'react';
import { IExamsList, WarningModal } from '../index';
import AccreditationCenterDetails from '../AccreditationCenterDetails/AccreditationCenterDetails';
import { IAccreditationCenterDetails, IExamsFilters, IQualificationInfoList } from '../models';
import { IQualificationsFilters } from '../reduxModels';

const AccreditationCenterDetailsModal: React.FC<IProps> = props => (
  <WarningModal
    large
    card
    withoutCancelButton
    withoutTitleMargin
    title={props.accreditationCenterDetails ? props.accreditationCenterDetails.name : ''}
    show={!!props.show}
    onHide={() => {
        props.onHide();
        if (props.clearAccreditationCenterQualifications) props.clearAccreditationCenterQualifications();
        props.clearExams();
        if (props.clearAccreditationCenterDetails) props.clearAccreditationCenterDetails();
    }}
  >
      {props.accreditationCenterDetails && (
        <AccreditationCenterDetails
          isAsc={props.isAsc}
          qualificationId={props.qualificationId}
          details={props.accreditationCenterDetails}
          getExams={props.getExams}
          exams={props.exams}
          qualifications={props.accreditationCenterQualifications}
          getQualifications={props.getAccreditationCenterQualifications}
        />
      )}
  </WarningModal>
);

interface IProps {
    show?: boolean;
    onHide: () => void;

    exams: IExamsList | null;
    accreditationCenterDetails: IAccreditationCenterDetails | null;
    accreditationCenterQualifications?: IQualificationInfoList | null;
    isAsc?: boolean;
    qualificationId?: string;

    getExams: (payload: IExamsFilters) => Promise<void>;
    getAccreditationCenterQualifications?: (payload: IQualificationsFilters) => Promise<void>;
    clearAccreditationCenterQualifications?: () => void;
    clearAccreditationCenterDetails?: () => void;
    clearExams: () => void;
}

export default AccreditationCenterDetailsModal;
